/* Store Locator — Petit Blush
   Leaflet + OpenStreetMap. No API key. Reads store data from an inline JSON
   script tag and a config object on the section root element. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.slInit === '1') return;
    root.dataset.slInit = '1';

    var dataEl = root.querySelector('[data-sl-data]');
    var mapEl = root.querySelector('[data-sl-map]');
    var listEl = root.querySelector('[data-sl-list]');
    var emptyEl = root.querySelector('[data-sl-empty]');
    var searchEl = root.querySelector('[data-sl-search]');
    var filterEl = root.querySelector('[data-sl-filter]');
    var countEl = root.querySelector('[data-sl-count]');
    if (!dataEl || !mapEl || !listEl || typeof L === 'undefined') return;

    var stores;
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    stores = stores.filter(function (s) {
      return typeof s.lat === 'number' && typeof s.lng === 'number';
    });

    var countTpl = root.dataset.countTemplate || '%count% stores';

    var map = L.map(mapEl, {
      scrollWheelZoom: false,
      attributionControl: true
    });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap'
    }).addTo(map);
    mapEl.classList.remove('is-loading');

    // Enable wheel zoom only after click (avoids hijacking page scroll)
    map.on('focus', function () { map.scrollWheelZoom.enable(); });
    map.on('blur', function () { map.scrollWheelZoom.disable(); });

    // Read the brand accent token so the pin follows a single-token accent swap; fall back to the rose hex.
    var pinColor = (getComputedStyle(document.documentElement).getPropertyValue('--pb-accent') || '').trim() || '#d5777c';
    var pinSvg =
      '<span class="store-locator__pin"><svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M14 1C8.2 1 3.5 5.7 3.5 11.5C3.5 19 14 27 14 27S24.5 19 24.5 11.5C24.5 5.7 19.8 1 14 1Z" ' +
      'fill="' + pinColor + '" stroke="#ffffff" stroke-width="1.5"/>' +
      '<circle cx="14" cy="11.5" r="3.6" fill="#ffffff"/></svg></span>';

    function makeIcon() {
      return L.divIcon({
        className: 'store-locator__marker',
        html: pinSvg,
        iconSize: [28, 28],
        iconAnchor: [14, 27],
        popupAnchor: [0, -24]
      });
    }

    var markers = {};
    var items = {};
    var activeId = null;

    function setActive(id, fromMap) {
      if (activeId && items[activeId]) items[activeId].classList.remove('is-active');
      if (activeId && markers[activeId]) {
        var prev = markers[activeId]._icon;
        if (prev) prev.classList.remove('is-active');
      }
      activeId = id;
      if (!id) return;
      if (items[id]) {
        items[id].classList.add('is-active');
        if (fromMap) items[id].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      if (markers[id] && markers[id]._icon) markers[id]._icon.classList.add('is-active');
    }

    stores.forEach(function (s) {
      var m = L.marker([s.lat, s.lng], { icon: makeIcon(), title: s.name });
      var pCountry = countryLabel(s.country);
      var html =
        '<span class="store-locator__popup-name">' + esc(s.name) + '</span>' +
        esc(s.address) +
        (pCountry ? '<br>' + esc(pCountry) : '');
      if (s.web) {
        html +=
          '<br><a class="store-locator__popup-link" href="' +
          esc(s.web) +
          '" target="_blank" rel="noopener">' +
          esc(root.dataset.websiteLabel || 'Website') +
          '</a>';
      }
      m.bindPopup(html);
      m.on('click', function () { setActive(s.id, true); });
      m.addTo(map);
      markers[s.id] = m;
    });

    function esc(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function countryLabel(cc) {
      if (!cc) return '';
      var key = 'country' + cc.charAt(0).toUpperCase() + cc.slice(1).toLowerCase();
      return root.dataset[key] || cc;
    }

    function fitTo(list) {
      var pts = list
        .filter(function (s) { return markers[s.id]; })
        .map(function (s) { return [s.lat, s.lng]; });
      if (pts.length === 1) {
        map.setView(pts[0], 13);
      } else if (pts.length > 1) {
        map.fitBounds(pts, { padding: [40, 40] });
      }
    }

    function render() {
      var q = (searchEl && searchEl.value || '').trim().toLowerCase();
      var country = filterEl && filterEl.value || '';
      var visible = stores.filter(function (s) {
        if (country && s.country !== country) return false;
        if (!q) return true;
        return (
          s.name.toLowerCase().indexOf(q) !== -1 ||
          (s.city || '').toLowerCase().indexOf(q) !== -1 ||
          (s.zip || '').toLowerCase().indexOf(q) !== -1
        );
      });

      listEl.innerHTML = '';
      items = {};
      visible.forEach(function (s) {
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'store-locator__item';
        var cLabel = countryLabel(s.country);
        btn.innerHTML =
          '<p class="store-locator__item-name">' + esc(s.name) + '</p>' +
          '<p class="store-locator__item-address">' + esc(s.address) + '</p>' +
          (cLabel
            ? '<p class="store-locator__item-country">' + esc(cLabel) + '</p>'
            : '');
        var links = '';
        if (s.web) {
          links +=
            '<a class="store-locator__item-link" href="' + esc(s.web) +
            '" target="_blank" rel="noopener" data-sl-stop>' +
            esc(root.dataset.websiteLabel || 'Website') + '</a>';
        }
        links +=
          '<a class="store-locator__item-link" target="_blank" rel="noopener" data-sl-stop href="https://www.google.com/maps/dir/?api=1&destination=' +
          encodeURIComponent(s.lat + ',' + s.lng) + '">' +
          esc(root.dataset.directionsLabel || 'Directions') + '</a>';
        if (links) {
          var wrap = document.createElement('div');
          wrap.className = 'store-locator__item-links';
          wrap.innerHTML = links;
          btn.appendChild(wrap);
        }
        btn.addEventListener('click', function (e) {
          if (e.target.closest('[data-sl-stop]')) return;
          map.setView([s.lat, s.lng], 14, { animate: true });
          markers[s.id].openPopup();
          setActive(s.id, false);
        });
        li.appendChild(btn);
        listEl.appendChild(li);
        items[s.id] = btn;
      });

      if (countEl) countEl.textContent = countTpl.replace('%count%', visible.length);
      if (emptyEl) emptyEl.hidden = visible.length !== 0;
      fitTo(visible);
    }

    if (searchEl) searchEl.addEventListener('input', debounce(render, 180));
    if (filterEl) filterEl.addEventListener('change', render);
    render();
    setTimeout(function () { map.invalidateSize(); }, 200);
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, ms);
    };
  }

  function boot() {
    document.querySelectorAll('[data-sl-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
